module.exports = __webpack_public_path__ + "img/tramites-colores.46e93cbf.png";